<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected" class="varieables">
        <b-card class="card">
          <div class="inp">
            <label>{{ $t('pressao-na-saida-bar') }} </label>
            <input min="0" step="0.1" v-model="pSaida.value" type="number" />
          </div>

          <div v-if="this.Opt.value != 4" class="inp">
            <label>{{ $t('temperatura-na-saida-oc') }} </label>
            <input min="0" step="0.1" v-model="TSaida.value" type="number" />
          </div>

          <div v-if="this.Opt.value == 4" class="inp">
            <label>{{ $t('temperatura-na-saida-oc-0') }} </label>
            <p>{{ this.TSaida.value | ParseNumber }}</p>
          </div>

          <div class="inp">
            <label>{{ $t('capacidade-ton-h') }} </label>
            <input
              min="0"
              step="0.1"
              v-model="Capacidade.value"
              type="number"
            />
          </div>
        </b-card>
        <b-card class="card">
          <div class="inp">
            <label>{{ $t('consumo-especifico-kg-kw-h') }} </label>
            <p>{{ this.ConsumoEspecifico.value | ParseNumber }}</p>
          </div>

          <div class="inp">
            <label>{{ $t('ocupacao-1') }} </label>
            <p>{{ this.Ocupacao.value | ParseNumber }}</p>
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { FiltersMixin } from "../../../mixins/filtersMixin";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [FiltersMixin],

  data() {
    return {
      pSaida: {},
      tSaida: {},
      Capacidade: {},
      Opt: {},
      ConsumoEspecifico: {},
      Ocupacao: {},
      operations: [{ value: null, text:this.$t('selecione-uma-turbina-0')  }],
      operationSelected: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-uma-turbina-0'),
      firstLoad: false,
      attrList: [
        "pSaida",
        "TSaida",
        "Capacidade",
        "Opt",
        "ConsumoEspecifico",
        "Ocupacao",
      ],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });
      this.updateNode();
    },

    "pSaida.value"() {
      this.updateNode();
    },

    "TSaida.value"() {
      this.updateNode();
    },

    "Capacidade.value"() {
      this.updateNode();
    },

    "Opt.value"() {
      this.updateNode();
    },
  },
  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.caption == a) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
        });
      });
    },

    updateNode() {
      let attrs = [
        this.pSaida.clone(),
        this.TSaida.clone(),
        this.Capacidade.clone(),
      ];

      if (this.Opt && this.Opt.value) {
        attrs.push(this.Opt);
      }
      this.node.attrs = attrs;
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Turbina/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    setTimeout(this.loadNode(), 200);
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

.card {
  margin: 10px;
}

input,
p {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.op {
  margin: 2%;
}
</style>